export interface IReliability {
  /** Блок надежности **/
  reliableBlock: IReliabilityBlock;
  /** Параметры надежности **/
  reliableParams: IReliableParams[];
}

export interface IReliabilityBlock {
  /** Описание блока **/
  description?: string;
  /** Лейбл **/
  label?: string;
  /** Текст блока **/
  text: string;
  /** Тип блока **/
  type: EReliabilityType;
}

export enum EReliabilityType {
  /** Неудача **/
  'Problem' = 'problem',
  /** Успех **/
  'Reliable' = 'reliable',
}

export interface IReliableParams {
  /** Подзаголовок **/
  subtitle?: string;
  /** Заголовок **/
  title: string;
  /** Тип параметра **/
  type: EReliableParamType;
}

export enum EReliableParamType {
  /** Неудача **/
  'Failure' = 'failure',
  /** В процессе проверки **/
  'InProgress' = 'inProgress',
  /** Успех **/
  'Success' = 'success',
  /** Предупреждение **/
  'Warning' = 'warning',
}
